import { render } from "./HeaderWidget.vue?vue&type=template&id=105a3ef0&scoped=true&ts=true"
import script from "./HeaderWidget.vue?vue&type=script&lang=ts"
export * from "./HeaderWidget.vue?vue&type=script&lang=ts"

import "./HeaderWidget.vue?vue&type=style&index=0&id=105a3ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105a3ef0"]])

export default __exports__